import React, { useEffect, useState } from 'react'
import endpoint from "../../../auth/endpoint";
import Loader from "react-loader-advanced";
import './CounselCauseListCustomPrint.css'

const CauseListCounselWithSisterCustomPrint = () => {
    const [isLoading, setLoading] = useState(false);
    const [dailyCauseList, setDailyCauseList] = useState([]);
    const [date, setDate] = useState('');
    const [customCauseList, setCustomCauseList] = useState({});
    const [selectedLocation, setSelectedLocation] = useState("All");
    const [isVisible, setIsVisible] = useState(true);
    const [showCustomSection, setShowCustomSection] = useState(false);
    
    // State to track which headings have their header checkbox checked
    const [checkedHeadings, setCheckedHeadings] = useState({});
    
    // State to store custom header text for each heading
    const [customHeaderTexts, setCustomHeaderTexts] = useState({});
    
    // New state to track the location for each checked heading
    const [headingLocations, setHeadingLocations] = useState({});

    //add suffix to date
    const dateSuffix = (day) => {
        if ((day == 1) || (day == 21) || (day == 31)) {
            return day + '' + "st";
        } else if ((day == 2) || (day == 22)) {
            return day + '' + "nd";
        } else if ((day == 3) || (day == 23)) {
            return day + '' + "rd";
        } else {
            return day + '' + "th";
        }
    }

    const formattedDate = date && (new Date(date).toLocaleDateString('en-us', { weekday: "long" }) + ", " + dateSuffix(new Date(date).toLocaleDateString('en-us', { day: "numeric" })) + " day of " +
        new Date(date).toLocaleDateString('en-us', { month: "long" }) + ", " + new Date(date).toLocaleDateString('en-us', { year: "numeric" })).toUpperCase();

    const curDate = new Date()
    const dateStr = (curDate.toLocaleDateString('en-us', { weekday: "long" }) + ", " + dateSuffix(curDate.toLocaleDateString('en-us', { day: "numeric" })) + " day of " +
        curDate.toLocaleDateString('en-us', { month: "long" }) + ", " + curDate.toLocaleDateString('en-us', { year: "numeric" })).toUpperCase();

    const alphabetArray = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

    const todaysDate = () => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    useEffect(() => {
        getDailyCauseList()
    }, [])

    const getDailyCauseList = async () => {
        setLoading(true);
        await endpoint.get(`/case-diary/new-day-list/${todaysDate()}`)
            .then(({ data }) => {
                let causeArr = data.data;
                // Group by location first
                const groupedByLocation = causeArr.reduce((result, obj) => {
                    const location = obj.location || 'N/A';
                    
                    if (!result[location]) {
                        result[location] = {};
                    }
                    
                    const key = obj.CaseType.case_type + ' ' + obj.CaseTypeCategory.case_type_cat;
                    
                    if (!result[location][key]) {
                        result[location][key] = [];
                    }
                    
                    result[location][key].push(obj);
                    
                    return result;
                }, {});
                setDailyCauseList(groupedByLocation);
                setLoading(false);
            }).catch((err) => {
                console.log(err);
                setLoading(false);
            });
    }


    const handleFetchData = async () => {
        setLoading(true);
        await endpoint.get(`/case-diary/new-day-list/${date}`)
            .then(({ data }) => {
                let causeArr = data.data;
                const groupedByLocation = causeArr.reduce((result, obj) => {
                    const location = obj.location || 'N/A';

                    if (!result[location]) {
                        result[location] = {};
                    }

                    const key = obj.CaseType.case_type + ' ' + obj.CaseTypeCategory.case_type_cat;

                    if (!result[location][key]) {
                        result[location][key] = [];
                    }

                    result[location][key].push(obj);

                    return result;
                }, {});
                console.log("groupedByLocation", groupedByLocation);
                setDailyCauseList(groupedByLocation);
                setLoading(false);
            }).catch((err) => {
                console.log(err);
                setLoading(false);
            });
    }

    const checkedFnc = (e, Case, headings, location = "All") => {
        const caseWithMeta = { 
            ...Case, 
            heading: headings,
            location: location
        };

        if (e.target.checked) {
            // Group by heading
            setCustomCauseList(prev => {
                const newList = { ...prev };
                if (!newList[headings]) {
                    newList[headings] = [];
                }
                // Check if case already exists in this heading
                if (!newList[headings].some(item => item.suite_no === Case.suite_no)) {
                    newList[headings].push(caseWithMeta);
                }
                return newList;
            });
        } else {
            // Remove from specific heading
            setCustomCauseList(prev => {
                const newList = { ...prev };
                if (newList[headings]) {
                    newList[headings] = newList[headings].filter(item => item.suite_no !== Case.suite_no);
                    // Remove empty heading
                    if (newList[headings].length === 0) {
                        delete newList[headings];
                    }
                }
                return newList;
            });
        }
    }

    
    const customHeaderToggle = (e, headings, location) => {
        const isChecked = e.target.checked;
        
        // Update checked headings state
        setCheckedHeadings(prev => ({
            ...prev,
            [headings]: isChecked
        }));

        // Store the location for this heading
        if (isChecked) {
            setHeadingLocations(prev => ({
                ...prev,
                [headings]: location
            }));
        } else {
            setHeadingLocations(prev => {
                const newLocations = { ...prev };
                delete newLocations[headings];
                return newLocations;
            });
        }

        // If unchecking, remove all cases from this heading
        if (!isChecked) {
            setCustomCauseList(prev => {
                const newList = { ...prev };
                delete newList[headings];
                return newList;
            });
            // Also remove custom header text for this heading
            setCustomHeaderTexts(prev => {
                const newTexts = { ...prev };
                delete newTexts[headings];
                return newTexts;
            });
        }

        // Update showCustomSection based on whether any headers are checked
        const updatedCheckedHeadings = {
            ...checkedHeadings,
            [headings]: isChecked
        };
        const hasCheckedHeaders = Object.values(updatedCheckedHeadings).some(val => val === true);
        setShowCustomSection(hasCheckedHeaders);
    }

    const handleCustomHeaderTextChange = (headings, text) => {
        setCustomHeaderTexts(prev => ({
            ...prev,
            [headings]: text
        }));
    }

    const hideCauseList = () => {
        setIsVisible(!isVisible);
    }

    // Get unique locations from dailyCauseList
    const getLocations = () => {
        const locations = Object.keys(dailyCauseList);
        return ['All', ...locations];
    }

    // Get filtered custom cause list grouped by heading
    const getFilteredCustomCauseList = () => {
        let filtered = {};
        
        Object.entries(customCauseList).forEach(([heading, cases]) => {
            const filteredCases = cases.filter(caseItem => {
                if (selectedLocation === "All") return true;
                return caseItem.location === selectedLocation;
            });
            
            if (filteredCases.length > 0) {
                filtered[heading] = filteredCases;
            }
        });
        
        return filtered;
    }

    // Check if any custom cases are selected
    const hasCustomCases = () => {
        const filtered = getFilteredCustomCauseList();
        return Object.keys(filtered).length > 0;
    }

    // Check if any header is checked
    const anyHeaderChecked = () => {
        return Object.values(checkedHeadings).some(val => val === true);
    }

    // Function to sort headings like in the original code
    const sortHeadings = (headingsArray) => {
        return headingsArray.sort(([keyA], [keyB]) => {
            const isMotionA = keyA.toLowerCase().includes("motion");
            const isMotionB = keyB.toLowerCase().includes("motion");

            if (isMotionA && !isMotionB) return -1;
            if (!isMotionA && isMotionB) return 1;

            return keyA.localeCompare(keyB);
        });
    }

    // Updated function to get the location for the custom section
    const getCustomSectionLocation = () => {
        // First, check if we have any checked headings with stored locations
        const checkedHeadingsList = Object.keys(checkedHeadings).filter(h => checkedHeadings[h]);
        
        if (checkedHeadingsList.length > 0) {
            // Get locations from checked headings
            const locations = checkedHeadingsList
                .map(heading => headingLocations[heading])
                .filter(loc => loc && loc !== 'N/A' && loc !== 'All');
            
            // Remove duplicates
            const uniqueLocations = [...new Set(locations)];
            
            if (uniqueLocations.length === 1) {
                return uniqueLocations[0];
            } else if (uniqueLocations.length > 1) {
                return 'VARIOUS REGISTRIES';
            }
        }
        
        // If no checked headings with locations, try to get from cases
        if (selectedLocation === "All") {
            const allLocations = [];
            Object.values(customCauseList).forEach(cases => {
                cases.forEach(caseItem => {
                    if (caseItem.location && caseItem.location !== 'N/A' && !allLocations.includes(caseItem.location)) {
                        allLocations.push(caseItem.location);
                    }
                });
            });
            
            if (allLocations.length === 1) {
                return allLocations[0];
            } else if (allLocations.length > 1) {
                return 'VARIOUS REGISTRIES';
            } else {
                // If still no location found, check if we have any checked heading
                if (checkedHeadingsList.length > 0) {
                    // Try to find the location from the dailyCauseList for the first checked heading
                    for (const heading of checkedHeadingsList) {
                        for (const [location, groupings] of Object.entries(dailyCauseList)) {
                            if (groupings[heading]) {
                                return location;
                            }
                        }
                    }
                }
                // Return null or empty string when no location is found
                return '';
            }
        } else {
            return selectedLocation;
        }
    }

    return (
        <>
            {isVisible && 
                <div id='divToPrintCounselCauseList'>
                    <div className='row mt-4'>
                        <div className='col-md-12 text-center' style={{ textDecoration: `underline` }}> 
                            <h3>COUNSEL LIST</h3><br />
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col'>
                            <label className='text-danger' id='hideDate'>
                                <i>**Please select date and click on search to print cause list**</i>
                            </label>
                            <div className="input-group mb-3" id='hideDate'>
                                <input 
                                    type="date" 
                                    className="form-control" 
                                    value={date}
                                    onChange={(e) => setDate(e.target.value)}
                                />
                                <div className="input-group-append">
                                    <button className="btn btn-outline-primary" type="button" onClick={handleFetchData}>
                                        Search
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='col'></div>
                    </div>

                    {isLoading && <div className="d-flex align-items-center justify-content-center vh-100">
                        <img
                            src={"/loading.gif"}
                            alt={""}
                            className="img-fluid"
                            style={{ maxWidth: "50px" }}
                        />
                    </div>}

                    {!isLoading && Object.entries(dailyCauseList).length > 0 &&
                        <div className='row mt-4'>
                            <div className='col-md-12'>
                                {/* Print button at the top */}
                                <div className='row mb-3'>
                                    <div className='col-md-12 text-right'>
                                        <button className="btn btn-outline-primary hideBtn" type="button" onClick={() => window.print()}>
                                            Print Full List
                                        </button>
                                    </div>
                                </div>

                                {Object.entries(dailyCauseList).map(([location, groupings], locationIndex) => (
                                    <div key={locationIndex}>
                                        {/* Court header */}
                                        <div className='row'>
                                            <div className='col-md-12 text-center' style={{ textDecoration: `underline`, fontWeight: 'bold' }}> 
                                                <span>IN THE SUPREME COURT OF NIGERIA</span><br />
                                                HOLDEN AT ABUJA <br /> 
                                                CAUSE LIST FOR {date ? formattedDate : dateStr.toUpperCase()} <br/>
                                                {location.toUpperCase()}
                                            </div>
                                        </div>

                                        <div className='row mt-2 mb-3'>
                                            <div className='col-md-12 text-center'>
                                                Counsel are required to put their names opposite the cases in this list in which they are
                                                engaged and to supply the Registrar with lists of authorities they intend to cite.
                                            </div>
                                        </div>

                                        {sortHeadings(Object.entries(groupings)).map(([headings, items], index) => (
                                            <div className='counselListHeading' key={index}>
                                                <div className='table-reponsive'>
                                                    <table className="table table-striped table-bordered mb-5" style={{ tableLayout: `fixed`, width: `100%`, border: `1px solid black` }}>
                                                        <thead className="thead-light">
                                                            <tr>
                                                                <th rowSpan="2" style={{ border: `1px solid black`, width: `50px`, textAlign: 'center' }}>
                                                                    <input 
                                                                        type='checkbox' 
                                                                        onChange={(e) => customHeaderToggle(e, headings, location)}
                                                                        checked={checkedHeadings[headings] || false}
                                                                        title="Enable/Disable Custom List for this section"
                                                                    />
                                                                </th>
                                                                <th rowSpan="2" style={{ border: `1px solid black`, width: `70px`, textAlign: 'center' }}>
                                                                    <strong>SNO.</strong>
                                                                </th>
                                                                <th rowSpan="2" style={{ border: `1px solid black`, textAlign: 'center' }}>
                                                                    <strong>{alphabetArray[index]}. {headings.toUpperCase()}</strong>
                                                                </th>
                                                                <th colSpan="2" style={{ border: `1px solid black`, textAlign: `center` }}>
                                                                    <strong>COUNSEL'S NAME</strong>
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <th style={{ border: `1px solid black`, textAlign: 'center' }}>
                                                                    <strong>For Appellant</strong>
                                                                </th>
                                                                <th style={{ border: `1px solid black`, textAlign: 'center' }}>
                                                                    <strong>For Respondent</strong>
                                                                </th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {items.length > 0 && items.map((item, itemIndex) => (
                                                                <>
                                                                    {item.CaseAttachements && item.CaseAttachements.map((Case, caseIndex) => (
                                                                        <tr key={`${itemIndex}-${caseIndex}`}>
                                                                            <td style={{ border: `1px solid black`, textAlign: 'center', verticalAlign: 'middle' }}>
                                                                                <input 
                                                                                    type='checkbox' 
                                                                                    onChange={(e) => checkedFnc(e, Case, headings, location)}
                                                                                />
                                                                            </td>
                                                                            {(caseIndex === 0) && 
                                                                                <td rowSpan={item.CaseAttachements.length} style={{ border: `1px solid black`, textAlign: 'center', verticalAlign: 'top' }}>
                                                                                    {itemIndex + 1}.
                                                                                </td>
                                                                            }
                                                                            <td style={{ 
                                                                                    border: '1px solid black', 
                                                                                    textAlign: 'center',
                                                                                    wordWrap: 'break-word',
                                                                                    maxWidth: '150px', 
                                                                                    minWidth: '150px',
                                                                                    whiteSpace: 'normal'
                                                                                }}>
                                                                                <div>
                                                                                    <strong>{Case.suite_no}</strong>
                                                                                </div>
                                                                                <div style={{ marginTop: '10px' }}>
                                                                                    {Case.appellants}
                                                                                    {Case.otherAppellantCount === 1 ? (
                                                                                        <><strong> & Anor </strong></>
                                                                                    ) : Case.otherAppellantCount > 1 ? (
                                                                                        <> & <strong>{Case.otherAppellantCount} Ors</strong></>
                                                                                    ) : (
                                                                                        ""
                                                                                    )} ({Case.appellants_title})
                                                                                </div>
                                                                                <div style={{ marginTop: '5px', textAlign: 'center' }}>
                                                                                    <strong>VS.</strong>
                                                                                </div>
                                                                                <div style={{ marginTop: '5px' }}>
                                                                                    {Case.respondent}
                                                                                    {Case.otherRespondentCount === 1 ? (
                                                                                        <><strong> & Anor </strong></>
                                                                                    ) : Case.otherRespondentCount > 1 ? (
                                                                                        <> & <strong>{Case.otherRespondentCount} Ors</strong></>
                                                                                    ) : (
                                                                                        ""
                                                                                    )} ({Case.respondent_title})
                                                                                </div>
                                                                            </td>
                                                                            <td style={{ border: `1px solid black` }}></td>
                                                                            <td style={{ border: `1px solid black` }}></td>
                                                                        </tr>
                                                                    ))}
                                                                </>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>
                    }

                    {/* Print button at the bottom */}
                    {!isLoading && Object.entries(dailyCauseList).length > 0 &&
                        <div className='row mt-4'>
                            <div className='col-md-12 text-right'>
                                <button className="btn btn-outline-primary hideBtn" type="button" onClick={() => window.print()}>
                                    Print Full List
                                </button>
                            </div>
                        </div>
                    }
                </div>
            }

            {/* Custom Counsel List Section - Only show when ANY header checkbox is checked */}
            {showCustomSection && (
                <div id='customCauseListPrint'>
                    <div className='row hideCustomHeader'>
                        <h5 className='text-center'>CUSTOM COUNSEL LIST SECTION</h5>
                    </div>

                    <div className='row'>
                        <div className='col-md-12 text-center' style={{ textDecoration: `underline`, fontWeight: 'bold' }}> 
                            <span>IN THE SUPREME COURT OF NIGERIA</span><br />
                            HOLDEN AT ABUJA <br />
                            CAUSE LIST FOR {date ? formattedDate : dateStr.toUpperCase()} <br/>
                            {getCustomSectionLocation() && getCustomSectionLocation().toUpperCase()}
                        </div>
                    </div>

                    <div className='row mt-2 mb-3'>
                        <div className='col-md-12 text-center'>
                            Counsel are required to put their names opposite the cases in this list in which they are
                            engaged and to supply the Registrar with lists of authorities they intend to cite.
                        </div>
                    </div>


                    <div>
                        {/* Show sections for ALL checked headers, even if they have no cases yet */}
                        {Object.keys(checkedHeadings)
                            .filter(heading => checkedHeadings[heading])
                            .map((heading, headingIndex) => {
                                // Get cases for this heading if any
                                const casesForHeading = getFilteredCustomCauseList()[heading] || [];
                                
                                return (
                                    <div key={heading} className='row mt-4'>
                                        <div className='col-md-12'>
                                            <div className='counselListHeading'>
                                                {/* Custom header input for this specific heading - hidden on print */}
                                                <div className='row mb-3 hide-on-print'>
                                                    <div className='col-md-12'>
                                                        <div className="input-group">
                                                            <input
                                                                className='form-control'
                                                                type="text"
                                                                placeholder={`Enter custom header for "${heading}" here`}
                                                                value={customHeaderTexts[heading] || ''}
                                                                onChange={(e) => handleCustomHeaderTextChange(heading, e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                {/* Display the custom header or default heading */}
                                                <div className='text-center mb-2' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                                                    {customHeaderTexts[heading] ? (
                                                        <div className="custom-header-text text-black">
                                                            {customHeaderTexts[heading]}
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            {alphabetArray[headingIndex]}. {heading.toUpperCase()}
                                                        </div>
                                                    )}
                                                </div>
                                                
                                                <div className='table-reponsive'>
                                                    <table className="table table-striped table-bordered mb-5" style={{ tableLayout: `fixed`, width: `100%`, border: `1px solid black` }}>
                                                        <thead className="thead-light">
                                                            <tr>
                                                                <th style={{ border: `1px solid black`, width: `80px`, textAlign: 'center', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>
                                                                    <strong>SNo.</strong>
                                                                </th>
                                                                <th style={{ border: `1px solid black`, textAlign: 'center' }}>
                                                                    <strong>APPEAL NO. & PARTIES</strong>
                                                                </th>
                                                                <th colSpan="2" style={{ border: `1px solid black`, textAlign: `center` }}>
                                                                    <strong>COUNSEL'S NAME</strong>
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <th style={{ border: `1px solid black`, width: `80px` }}></th>
                                                                <th style={{ border: `1px solid black` }}></th>
                                                                <th style={{ border: `1px solid black`, textAlign: 'center', width: '35%' }}>
                                                                    <strong>For Appellant</strong>
                                                                </th>
                                                                <th style={{ border: `1px solid black`, textAlign: 'center', width: '35%' }}>
                                                                    <strong>For Respondent</strong>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {casesForHeading.length > 0 ? (
                                                                casesForHeading.map((Case, index) => (
                                                                    <tr key={`${heading}-${Case.suite_no}-${index}`}>
                                                                        <td style={{ border: `1px solid black`, textAlign: 'center', verticalAlign: 'top', width: `80px` }}>
                                                                            {index + 1}.
                                                                        </td>
                                                                        <td style={{ 
                                                                            border: '1px solid black', 
                                                                            textAlign: 'center',
                                                                            wordWrap: 'break-word',
                                                                            maxWidth: '150px',
                                                                            minWidth: '150px',
                                                                            whiteSpace: 'normal'
                                                                        }}>
                                                                            <div>
                                                                                <strong>{Case.suite_no}</strong>
                                                                            </div>
                                                                            <div style={{ marginTop: '10px' }}>
                                                                                {Case.appellants}
                                                                                {Case.otherAppellantCount === 1 ? (
                                                                                    <><strong> & Anor </strong></>
                                                                                ) : Case.otherAppellantCount > 1 ? (
                                                                                    <> & <strong>{Case.otherAppellantCount} Ors</strong></>
                                                                                ) : (
                                                                                    ""
                                                                                )} ({Case.appellants_title})
                                                                            </div>
                                                                            <div style={{ marginTop: '5px', textAlign: 'center' }}>
                                                                                <strong>VS.</strong>
                                                                            </div>
                                                                            <div style={{ marginTop: '5px' }}>
                                                                                {Case.respondent}
                                                                                {Case.otherRespondentCount === 1 ? (
                                                                                    <><strong> & Anor </strong></>
                                                                                ) : Case.otherRespondentCount > 1 ? (
                                                                                    <> & <strong>{Case.otherRespondentCount} Ors</strong></>
                                                                                ) : (
                                                                                    ""
                                                                                )} ({Case.respondent_title})
                                                                            </div>
                                                                        </td>
                                                                        <td style={{ border: `1px solid black` }}></td>
                                                                        <td style={{ border: `1px solid black` }}></td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                // Empty table body - no cases selected yet for this heading
                                                                <tr>
                                                                    <td colSpan="4" className="text-center" style={{ border: `1px solid black`, padding: '50px' }}>
                                                                        <i>No cases selected yet for this section. Check the boxes in the counsel list above to add cases.</i>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}

                        <div className='col-md-12 hideCustomBtn'>
                            <p className='hideBtn hide-on-print'>
                                <i>
                                    <span className='text-danger'>***</span>
                                    Please click on Hide Counsel List before printing custom counsel list
                                    <span className='text-danger'>***</span>
                                </i>
                            </p>

                            <div className="button-group hide-on-print">
                                {isVisible && 
                                    <button className="btn btn-outline-primary hideBtn mr-2" type="button" onClick={hideCauseList}>
                                        Hide Counsel List
                                    </button>
                                }
                                {!isVisible && 
                                    <button className="btn btn-outline-primary hideBtn mr-2" type="button" onClick={hideCauseList}>
                                        View Counsel List
                                    </button>
                                }
                                <button className="btn btn-outline-primary hideBtn mr-2" type="button" onClick={() => window.print()}>
                                    Print Custom Counsel List
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default CauseListCounselWithSisterCustomPrint;